module.exports = __webpack_public_path__ + "img/SGP.527cb173.svg";